import { css, StyleSheet } from 'aphrodite'
import * as React from 'react'

import style from '../utils/style'
import * as iso from './iso'

export type OverlayState = 'selected' | 'hover' | 'target'
  | 'moveTarget' | 'threat' | 'dangerMove' | 'threatAttacker'
  | 'areaOfEffect' | 'currentTarget'

interface IProps {
  state: OverlayState[]
}

const styles = StyleSheet.create({
  main: {
    fill: 'transparent',
    strokeWidth: '.2%',
  },

  selected: {
    stroke: style.gold,
  },

  hover: {
    stroke: 'rgba(0, 0, 0, 0.3)',
  },

  target: {
    fill: 'rgba(255, 0, 0, 0.16)',
  },
  currentTarget: {
    fill: 'rgba(255, 0, 0, 0.38)',
  },
  moveTarget: {
    fill: 'rgba(255, 255, 255, 0.17)',
  },
  threat: {
    fill: 'rgba(255, 160, 0, 0.14)',
  },
  dangerMove: {
    fill: 'rgba(255, 80, 0, 0.32)',
    stroke: 'rgba(255, 80, 0, 0.8)',
  },
  threatAttacker: {
    fill: 'rgba(255, 80, 0, 0.18)',
    stroke: 'rgba(255, 80, 0, 0.95)',
  },

  areaOfEffect: {
    fill: 'rgba(255, 0, 0, 0.2)', stroke: 'rgba(255, 0, 0, 0.2)',
  },
})

export default class TileOverlay extends React.PureComponent<IProps, void> {
  render() {
    const { state, ...props } = this.props
    const classes = css(styles.main, ...state.map(s => styles[s]))
    return (
      <polygon points={iso.drawHex(.96)} className={classes} {...props} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/stageView/tileOverlay.tsx